module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmpage"
  }, [_c('h1', {
    staticClass: "chnumber"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noIndent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Bitters, Texas")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noIndent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Thursday, August 24, 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "noIndent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("10:30 p.m. CST")])]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak1"
  }, [_c('span', {
    staticClass: "dp"
  }, [_vm._v("W")]), _vm._v("ith a sharp strike against the small box’s score, the match ignited. A flash of light, a ghostly puff of smoke, the nose-stinging scent of sulfur, and it was done. The arsonist’s ragged emotions were set free. Instantly, any doubt or anxiety about this decision vanished, replaced by righteous conviction.")]), _vm._v(" "), _c('p', [_vm._v("The flame stayed steady and bright as it was lowered to the mass of dry wood piled on the board stairs leading to the church’s vestibule. Whole lengths of browned evergreen branches and other dead vegetation had been easy to collect, thanks to the wild terrain and yet another year of drought.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("As expected, the brittle debris caught quickly. Flowing like liquid, the flames spread, advanced and climbed. It wouldn’t be long before they gave birth to a torch, a pyre, a veritable shaking fist ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("against this serene night, this star-studded summer sky, luminous and wide, unmarred by the slightest hint of a cloud. This silent witness to everything.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', [_vm._v("Soon the vestibule doors would catch, and then…maybe the interior. It was possible if help was slow to respond.")]), _vm._v(" "), _c('p', [_vm._v("Tossing the box of matches into the intensifying blaze, escape became the next focus. There might not be anyone on this remote highway tonight, but there was always the chance an alert trucker on I–10, or worse, a state trooper, would spot the distant glow and mention it on his radio, initiating an alarm too soon. However, the arsonist’s escape vehicle was parked facing the road; even that had been thought through. What hadn’t been was the unreliable nature of the vehicle itself.")]), _vm._v(" "), _c('p', [_vm._v("It took try after terrifying try, but just as the smell of gasoline could be detected, the engine finally roared to life and the arsonist peeled out of the lot making a skidding turn west onto the unlit single-lane highway.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321ed243","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781460362648_fm005.vue
// module id = 81
// module chunks = 0